import { default as MeetingsList } from './MeetingsList';

export default MeetingsList;
